import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import DetailReport from './detailReport/DetailReport';
import ReportSearchBar from './reportSearchBar/ReportSearchBar';
import { customAxiosPostFunction } from 'utils/axiosFunction';
import './Report.css';

const Report = () => {
  const history = useHistory();
  const [reportMap, setReportMap] = useState({
    period: {
      selectedPeriod: {
        regular: false,
        week: false,
        month: false,
        quater: false,
        half: false,
        year: false,
        temporary: false,
      },
    },
    holding: {},
    operate: {},
    event: {},
    calibrate: {},
    detail: {},
  });
  const [searchMap, setSearchMap] = useState({
    beginDate: new Date(),
    endDate: new Date(),
  });

  const exportExcel = useCallback(() => {
    return customAxiosPostFunction(history, '/api/report/export', reportMap, {
      headers: {
        'Content-Disposition': 'attachment; filename=template.xlsx',
      },
      responseType: 'arraybuffer',
    })
      .then((response) => {
        const fileName = `UBiTOMS™ 레포트_${moment().format('YYYYMMDD')}.xlsx`;
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        alert('보고서 출력완료');
      })
      .catch(function (error) {
        alert('보고서 출력실패');
        console.log(error);
      });
  }, [reportMap]);

  return (
    <div className="reportContainer">
      <section>
        <ReportSearchBar exportExcel={exportExcel} searchMap={searchMap} setSearchMap={setSearchMap} />
        <DetailReport searchMap={searchMap} reportMap={reportMap} setReportMap={setReportMap} />
      </section>
    </div>
  );
};

export default Report;
